import React from 'react';

import styles from './BenefitCard.css';

export interface BenefitCardProps {
    iconSrc: string;
    text: string;
}

export function BenefitCard({ iconSrc, text }: BenefitCardProps) {
    return (
        <div className={styles.root}>
            <img className={styles.icon} src={iconSrc} alt="card icon" />
            <div className={styles.text}>{text}</div>
        </div>
    );
}
